import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faImage, faSync } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import './BannerData.css';
import NewBanner from '../NewBanner/NewBanner';

export default function BannerData() {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cargarBanners();
    }, []);

    const cargarBanners = () => {
        setLoading(true);
        fetch(`${baseURL}/bannersGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setBanners(data.banner || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar banners:', error);
                setLoading(false);
            });
    };

    const handleImageError = (e, originalUrl) => {
        const target = e.target;
        if (!target.dataset.fallbackStep) {
            target.dataset.fallbackStep = '1';
            // Paso 1: Extraer el nombre del archivo y probar vía baseURL (Apache)
            const filename = (originalUrl || '').split('/').pop();
            if (filename) {
                target.src = `${baseURL}/imagenes_banners/${filename}`;
                return;
            }
        }
        if (target.dataset.fallbackStep === '1') {
            target.dataset.fallbackStep = '2';
            // Paso 2: Probar ruta relativa directa del servidor de desarrollo
            const filename = (originalUrl || '').split('/').pop();
            if (filename) {
                target.src = `/imagenes_banners/${filename}`;
                return;
            }
        }
        // Paso 3: Si todo falla, mostrar logo por defecto
        target.src = '/logo.png';
    };

    const eliminarBanner = (idBanner) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡Se eliminará esta imagen de banner de forma permanente!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ef4444',
            cancelButtonColor: '#64748b',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/bannerDelete.php?idBanner=${idBanner}`, {
                    method: 'DELETE',
                    credentials: 'include',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje || 'Banner eliminado con éxito',
                            'success'
                        );
                        cargarBanners();
                    })
                    .catch(error => {
                        console.error('Error al eliminar banner:', error);
                        toast.error('No se pudo eliminar el banner');
                    });
            }
        });
    };

    return (
        <div className='BannerContainer'>
            <div className='bannerHeaderRow' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
                <NewBanner onBannerCreated={cargarBanners} />
                <button
                    type="button"
                    onClick={cargarBanners}
                    className="btnSecondarySeo"
                    style={{ background: '#ffffff', border: '1px solid #cbd5e1', borderRadius: '10px', padding: '8px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 600, color: '#334155' }}
                    title="Recargar banners"
                    disabled={loading}
                >
                    <FontAwesomeIcon icon={faSync} spin={loading} />
                    <span>Actualizar ({banners.length})</span>
                </button>
            </div>

            {loading ? (
                <div style={{ textAlign: 'center', padding: '3rem 1rem', color: '#64748b' }}>
                    <FontAwesomeIcon icon={faSync} spin style={{ fontSize: '2rem', marginBottom: '1rem', color: 'var(--color1, #059669)' }} />
                    <p>Cargando banners...</p>
                </div>
            ) : banners.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '3rem 1.5rem', background: '#f8fafc', borderRadius: '16px', border: '2px dashed #cbd5e1' }}>
                    <FontAwesomeIcon icon={faImage} style={{ fontSize: '3rem', color: '#94a3b8', marginBottom: '1rem' }} />
                    <h3 style={{ margin: '0 0 0.5rem', color: '#334155', fontWeight: 700 }}>No hay banners registrados</h3>
                    <p style={{ margin: 0, color: '#64748b', fontSize: '0.95rem' }}>Haz clic en "+ Agregar" para subir tu primer banner panorámico para la agencia de viajes.</p>
                </div>
            ) : (
                <div className='BannerWrap'>
                    {banners.map(item => (
                        <div className='cardBanner' key={item.idBanner}>
                            <img
                                src={item.imagen}
                                alt="banner"
                                onError={(e) => handleImageError(e, item.imagen)}
                            />
                            <button
                                type="button"
                                className='btnBannerDelete'
                                onClick={() => eliminarBanner(item.idBanner)}
                                title="Eliminar banner"
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

